import {
  CREATE_BENEFIT_GROUP_ITEM,
  CREATE_BENEFIT_GROUP_ITEM_SUCCESS,
  CREATE_BENEFIT_GROUP_ITEM_ERROR,
  CREATE_BENEFIT_GROUP_ITEM_EMPTY,
} from './../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const CreateBenefitGroupItems = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_BENEFIT_GROUP_ITEM:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case CREATE_BENEFIT_GROUP_ITEM_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case CREATE_BENEFIT_GROUP_ITEM_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: null,
      };
      break;

    case CREATE_BENEFIT_GROUP_ITEM_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default CreateBenefitGroupItems;
